module.exports = __webpack_public_path__ + "assets/images/05_active_7c83fd4794f453efe5528fbe2b7fd216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/05_active.png
// module id = 170
// module chunks = 0